import { Avatar, Box, Divider, Typography, useTheme } from "@mui/material"
import { useTranslation } from "providers/i18n"
import { StoreIcon } from "components/icons"
import { IMultiLanguageInfo } from "utils/feature"

export interface ShopPromotionHeaderProps {
  occupantName: IMultiLanguageInfo | string
  logo?: string
}

export const ShopPromotionKioskVHeader: React.FC<ShopPromotionHeaderProps> = ({
  occupantName,
  logo = "",
}) => {
  const { t } = useTranslation()

  const theme = useTheme()

  const {
    root,
    headerContainer,
    headerLogo,
    headerTitle,
    divider,
    labelContainer,
    labelText,
  } = theme.components?.[`ShopPromotionHeader`].styleOverrides || {}

  return (
    <Box sx={root}>
      <Box sx={headerContainer}>
        <Avatar sx={headerLogo} src={logo}>
          <StoreIcon />
        </Avatar>
        <Typography variant="h5" sx={headerTitle}>
          {t(occupantName)}
        </Typography>
      </Box>

      <Divider orientation="vertical" sx={divider} />
      <Box sx={labelContainer}>
        <Typography sx={labelText} variant="h4">
          {t("Promotion")}
        </Typography>
      </Box>
    </Box>
  )
}
